import React from 'react';
import { CurrentUser } from '@graphql/types';
import { Mutation } from 'react-apollo';
import { CREATE_EVENT } from '@graphql/queries/create.event';
import { useAnalytics, useIdentify } from '@withjoy/web-core';
import { CreateEventMutation } from './components';

interface TyingTheKnot {
  currentUser?: CurrentUser;
  refetch: () => void;
}
export const TyingTheKnot: React.SFC<TyingTheKnot> = ({ currentUser, refetch }) => {
  const { track, trackError } = useAnalytics({
    category: 'CreateWedding',
    page: 'tyingTheKnot',
    pagePrefix: 'marketing',
    referrerOverride: 'https://withjoy.com/callback'
  });

  const { identify } = useIdentify();

  return (
    <Mutation mutation={CREATE_EVENT}>
      {(createEvent: any) => (
        <CreateEventMutation
          identify={identify}
          track={track}
          trackError={trackError}
          refetch={refetch}
          currentUser={currentUser}
          createEvent={createEvent}
        />
      )}
    </Mutation>
  );
};
